import React from 'react';
import '../styles/article-detail.css';

interface Paper {
  title: string;
  authors: string[];
  summary: string;
  published: string;
  link: string;
}

interface ArticleDetailProps {
  paper: Paper;
  onClose: () => void;
  source: 'arxiv' | 'crossref';
}

export const ArticleDetail: React.FC<ArticleDetailProps> = ({ paper, onClose, source }) => {
  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  const getArxivLink = (link: string) => {
    if (source === 'crossref') return link;
    // Ensure we're linking to the arXiv abstract page
    if (link.includes('arxiv.org/pdf/')) {
      return link.replace('/pdf/', '/abs/').replace('.pdf', '');
    }
    return link;
  };

  return (
    <div className="article-detail-overlay" onClick={onClose}>
      <div className="article-detail-modal" onClick={(e) => e.stopPropagation()}>
        <div className="article-detail-header">
          <h2 className="article-title">{paper.title}</h2>
          <button className="close-button" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <div className="article-meta">
          <div className="authors-section">
            <strong>Authors:</strong>
            <span className="authors">{paper.authors.join(', ')}</span>
          </div>
          <div className="published-section">
            <strong>Published:</strong>
            <span className="published-date">{formatDate(paper.published)}</span>
          </div>
        </div>

        <div className="abstract-section">
          <h3>Abstract</h3>
          <div className="abstract-content">
            {paper.summary}
          </div>
        </div>

        <div className="links-section">
          <h3>Links</h3>
          <div className="links-container">
            <a
              href={getArxivLink(paper.link)}
              target="_blank"
              rel="noopener noreferrer"
              className="link-button link-button-primary"
            >
              {source === 'arxiv' ? '📄 View on arXiv' : '🔗 View Article'}
            </a>
            {source === 'arxiv' && (
              <a
                href={getArxivLink(paper.link).replace('/abs/', '/pdf/') + '.pdf'}
                target="_blank"
                rel="noopener noreferrer"
                className="link-button link-button-secondary"
              >
                📥 Download PDF
              </a>
            )}
          </div>
        </div>

        <div className="article-detail-footer">
          <button className="back-button" onClick={onClose}>
            ← Back to Results
          </button>
        </div>
      </div>
    </div>
  );
};